import { render, staticRenderFns } from "./MarkSheetLessonAdmin.vue?vue&type=template&id=b227f3e8"
import script from "./MarkSheetLessonAdmin.vue?vue&type=script&lang=js"
export * from "./MarkSheetLessonAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports